import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect } from "react-router-dom";
import { DASHBOARD_ROUTES } from "./dashboardRoutes";
export function RootRedirect() {
    return _jsx(Redirect, { to: DASHBOARD_ROUTES.defaultPath });
}
